import { render, staticRenderFns } from "./RequestCanNotCommentOfferView.vue?vue&type=template&id=240b61d9"
import script from "./RequestCanNotCommentOfferView.vue?vue&type=script&lang=js"
export * from "./RequestCanNotCommentOfferView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports